import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

import {cn} from '@/lib/utils'

const Popover = PopoverPrimitive.Root
const PopoverTrigger = PopoverPrimitive.Trigger
type PopoverContentProps = PopoverPrimitive.PopoverContentProps

const PopoverContent = React.forwardRef<
    React.ElementRef<typeof PopoverPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> &
        PopoverContentProps & {
            'data-testid'?: string | undefined
        }
>(
    (
        {
            className,
            align = 'start',
            sideOffset = 4,
            alignOffset = 20,
            'data-testid': dataTestId,
            ...props
        },
        ref
    ) => (
        <PopoverPrimitive.Portal>
            <PopoverPrimitive.Content
                ref={ref}
                align={align}
                sideOffset={sideOffset}
                alignOffset={alignOffset}
                className={cn(
                    `z-50 w-[calc(100vw-1rem)] max-w-96 max-h-[80vh] overflow-auto border bg-white p-0 text-popover-foreground border-t-3 border-t-primary
                outline-none data-[state=open]:animate-in data-[state=closed]:animate-out
                data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95
                data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2
                data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2`,
                    className
                )}
                data-testid={dataTestId || 'PopoverContent'}
                {...props}
            />
        </PopoverPrimitive.Portal>
    )
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export {Popover, PopoverTrigger, PopoverContent}
